import { CardListSkeleton } from "./CardListSkeleton";
import { TableSkeleton } from "./TableSkeleton";

type Props = {
  isListView?: boolean;
  isCardView?: boolean;
  cardWithImage?: boolean;
};

export function BenefitSkeleton({ isListView, isCardView, cardWithImage }: Props) {
  if (isListView) {
    return <TableSkeleton />;
  }
  if (isCardView) {
    return <CardListSkeleton cardWithImage={cardWithImage} />;
  }

  return <CardListSkeleton cardWithImage={cardWithImage} />;
}
